export default "__VITE_ASSET__ffb72e23__"